<template>
    <uiv-modal v-model="open"
               title="Help Me Estimate"
               @show="goToHelpQuestion({ type: 'start' })">

        <progress-bar :percentage="progress"></progress-bar>

        <uiv-tabs v-model="helpMeEstimateStep" ref="tabs" class="tabs--hide">
            <uiv-tab title="house-type">
                <h5>What type of house do you have?</h5>

                <div class="row">
                    <div class="col-xs-6" v-for="item in houseTypeList" :key="item.id">
                        <radio-button v-model="helpMeEstimate.houseType"
                                      :value="item.id"
                                      @change="goToHelpQuestion({ type: 'next' })">
                            {{ item.name }}
                        </radio-button>
                    </div>
                </div>
            </uiv-tab>

            <uiv-tab title="number-of-bedrooms">
                <h5>How many bedrooms?</h5>

                <div class="row">
                    <div class="col-md-4" v-for="item in bedRoomList" :key="item.id">
                        <radio-button v-model="helpMeEstimate.numberOfBedrooms"
                                      :value="item.id"
                                      @change="goToHelpQuestion({ type: 'next' })">
                            {{ item.name }}
                        </radio-button>
                    </div>
                </div>
            </uiv-tab>

            <uiv-tab title="occupancy-frequency">
                <h5>When are people at home</h5>
                <div class="row">
                    <div class="col-md-12" v-for="item in occupancyFrequencyList" :key="item.id">
                        <radio-button v-model="helpMeEstimate.occupancyFrequency"
                                      :value="item.id"
                                      @change="goToHelpQuestion({ type: 'next' })">
                            {{ item.name }}
                        </radio-button>
                    </div>
                </div>
            </uiv-tab>

            <uiv-tab title="modernisation-level">
                <h5>Level of Modernisation</h5>
                <div class="row">
                    <div class="col-md-12" v-for="item in modernisationLevelList" :key="item.id">
                        <radio-button v-model="helpMeEstimate.modernisationLevel"
                                      :value="item.id"
                                      @change="goToHelpQuestion({ type: 'next' })">
                            {{ item.name }}
                        </radio-button>
                    </div>
                </div>
            </uiv-tab>

            <uiv-tab title="heating-and-cooking">
                <h5>Type of Heating & Cooking</h5>

                <div class="row">
                    <div class="col-md-12" v-for="item in fuelUseTypeList" :key="item.id">
                        <radio-button v-model="helpMeEstimate.heatingAndCooking"
                                      :value="item.id"
                                      @change="onDismissEstimateModal('calculate')">
                            {{ item.name }}
                        </radio-button>
                    </div>
                </div>
            </uiv-tab>
        </uiv-tabs>

        <div slot="footer">
            <uiv-btn @click="open = false">Cancel</uiv-btn>
        </div>
    </uiv-modal>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import ProgressBar from '../progress/ProgressBar';
import { mapState, mapActions, mapGetters } from 'vuex';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'HelpMeEstimate',
  data () {
    return {
      requesting: false,
      form: {},
      usageTab: 0,
      open: false
    };
  },
  validations: {
    form: {
      houseType: { required },
      numberOfBedrooms: { required },
      occupancyFrequency: { required },
      modernisationLevel: { required },
      heatingAndCooking: { required }
    }
  },
  mounted () {
    this.form = this.helpMeEstimate;
    this.initTabs(this.$refs.tabs.$children);
  },
  computed: {
    ...mapGetters({
      progress: 'help_me_estimate_questions/progress'
    }),
    ...mapState({
      quote: ({ quote }) => quote,
      usageTypeList: ({ lookups }) => lookups.usageTypes,
      usageUnitList: ({ lookups }) => lookups.usageUnits,
      helpMeEstimate: ({ help_me_estimate }) => help_me_estimate.model,
      helpMeEstimateStep: ({ help_me_estimate_questions }) => help_me_estimate_questions.step.tabIndex,
      houseTypeList: ({ lookups }) => lookups.houseTypes,
      bedRoomList: ({ lookups }) => lookups.bedRooms,
      occupancyFrequencyList: ({ lookups }) => lookups.occupancyFrequencies,
      modernisationLevelList: ({ lookups }) => lookups.energyEfficiencies,
      fuelUseTypeList: ({ lookups }) => lookups.fuelUseTypes,
      estimatedUsage: ({ help_me_estimate }) => help_me_estimate.estimated
    })
  },
  methods: {
    ...mapActions({
      initTabs: 'help_me_estimate_questions/getQuestions',
      goToQuestion: 'quote_questions/goToQuestion',
      goToHelpQuestion: 'help_me_estimate_questions/goToQuestion',
      calculate: 'help_me_estimate/calculate',
      resetEstimate: 'help_me_estimate/reset'
    }),
    openModal () {
      this.open = true;
      this.resetEstimate();
    },
    onDismissEstimateModal (action) {
      if (action === 'calculate') {
        this.$v.form.$touch();

        if (this.$v.form.$invalid) return;
        this.open = false;

        return this.calculate().then(() => {
          this.$emit('onClose', this.estimatedUsage);
        });
      }
    }
  },
  components: {
    RadioButton,
    ProgressBar
  }
};
</script>

<style lang="scss">

</style>
